$(document).ready(function(){
	
	$('.sec2_row').slick({
		slidesToShow:3,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		variableWidth:true,
		infinite:true,
		responsive: [
			{
				breakpoint: 1021,
				settings:{slidesToShow:2, slidesToScroll: 1, variableWidth:true,}
			},
			{
				breakpoint: 767,
				settings: "unslick"
			
			},
		]
	});
	
	/*==PACKAGE_SLIDER==*/
	$('.package_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package_slider_nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});

	$('.package_slider_nav').slick({
		slidesToShow:6,
		slidesToScroll: 1,
		asNavFor: '.package_slider',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
		rtl: false,
	});
	
	/*====PKG_OPT====*/
	$('.prd_opt').click(function(e) {
       $('.prd_opt').removeClass('active');
	   $(this).addClass('active');
    });
	
	$('.prd_opt').click(function(e) {
		if (!$(this).find(".pck_bx_rad").attr("checked")) {
			$(this).parent('.selectBox').find(".pck_bx_rad").removeAttr("checked");
			$(this).find(".pck_bx_rad").attr("checked", "checked");
		}
	});
	
	/*ACCORDION*/
	$(".accordion").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn_content');
		var idx = $('.acdn_content').index(answerDiv);
		
		$('.acdn_content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.accordion').removeClass('accordion_open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion_open');
			});
		} else {
		  questionDiv.addClass('accordion_open');
		  answerDiv.stop().slideDown(500);
		}
	});

	/*BUTTON_SCROLL*/
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 45
		}, 2000);
	});
	
	/*MENU_SCROLL*/
	$('ul.topMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 60
		}, 2000);
	});
	
	clock();
});


/*TIMER*/
var myTimer;
	
function clock() {
	var totalSeconds = 10 * 60 * 60; // Change 5 to the desired number of hours
	
	myTimer = setInterval(myClock, 1000);

	function myClock() {
		var hours = Math.floor(totalSeconds / 3600);
		var minutes = Math.floor((totalSeconds % 3600) / 60);
		var seconds = totalSeconds % 60;
		
		var result = "0" + hours + ":" + minutes + ":" + seconds + " ";
		
		
		var countdown2 = document.getElementsByClassName("listicle-count")
	
		for(var index=0;index < countdown2.length;index++){
		  countdown2[index].innerHTML = result;
		}

		totalSeconds--;

		if (totalSeconds < 0) {
			clearInterval(myTimer);
			for(var index=0;index < countdown2.length;index++){
			  countdown2[index].innerHTML = result;
			}
		}
	}
}

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();
	
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();
	
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 110){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
	var $elem = $('.fixed_btn');
		var $window = $(window);
	
		var docViewTop = $window.scrollTop();
		var docViewBottom = docViewTop + $window.height();
	
		var elemTop = $elem.offset().top;
		var elemBottom = elemTop + $elem.height();
	
		if (elemTop >= (docViewBottom + 20) || (elemTop + $('#call-btn').height()) >= (docViewBottom + 104)) {
				
			if (isScrolledIntoView('.section8') === true) {
				$('#call-btn').css('position', 'relative');
				
			} else {
				$('#call-btn').css('position', 'fixed');
			}
		} else {
			$('#call-btn').css({'position' : 'relative'});
		}
	
});